import { client } from '../../providers/data/client'

let whitelistCache = null
let cacheExpiry = 0

// Cache whitelist for 5 minutes to avoid repeated API calls
async function getWhitelist() {
  const now = Date.now()
  if (whitelistCache && now < cacheExpiry) {
    return whitelistCache
  }

  try {
    const response = await client().get('/util/whitelist')
    whitelistCache = response.data
    cacheExpiry = now + 5 * 60 * 1000 // 5 minutes
    return whitelistCache
  } catch (error) {
    console.error('Failed to fetch whitelist:', error)
    return { emails: [], phones: [], environment: 'unknown' }
  }
}

export const validateEmail = async (email) => {
  if (!email) return undefined

  const whitelist = await getWhitelist()

  // Only enforce whitelist in test and dev environments
  if (whitelist.environment !== 'test' && whitelist.environment !== 'dev') {
    return undefined
  }

  // If no emails in whitelist, no restrictions
  if (whitelist.emails.length === 0) {
    return undefined
  }

  if (!whitelist.emails.includes(email.toLowerCase())) {
    return `Email "${email}" is not whitelisted for ${whitelist.environment} environment. Allowed emails: ${whitelist.emails.join(
      ', '
    )}`
  }

  return undefined
}

export const validatePhone = async (phone) => {
  if (!phone) return undefined

  const whitelist = await getWhitelist()

  // Only enforce whitelist in test and dev environments
  if (whitelist.environment !== 'test' && whitelist.environment !== 'dev') {
    return undefined
  }

  // If no phones in whitelist, no restrictions
  if (whitelist.phones.length === 0) {
    return undefined
  }

  if (!whitelist.phones.includes(phone)) {
    return `Phone "${phone}" is not whitelisted for ${whitelist.environment} environment. Allowed phones: ${whitelist.phones.join(
      ', '
    )}`
  }

  return undefined
}

// Helper to create async validator for react-admin
export const createAsyncValidator = (validatorFn) => {
  return (value) => {
    return new Promise((resolve) => {
      validatorFn(value)
        .then(resolve)
        .catch(() => resolve(undefined))
    })
  }
}
